// 👇 Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// 👇 Axios Imports
import axios from 'axios'

import { urlTimeSheetService, urlInvoiceService } from '@src/endpoints'

import { getUriParams, twoDigitFormat } from '@src/utility/Utils'
import toast from 'react-hot-toast'
// 👇 Components
import { ToastContent } from "@src/views/components/toast/ToastContent"

const ToastMessage = (heading, message, isSuccess) => {
  toast(t => (
    <ToastContent t={t} heading = {heading} response = {isSuccess} message = {message} />
  ))
}
export const getAllData = createAsyncThunk('hrmTSReport/getAllData', async () => {
  const response = await axios.get(`${urlTimeSheetService}/GetAllTimeSheetsCount`)
  return {
    data: response.data,
    loadedAll: true
  }
})

export const getData = createAsyncThunk('hrmTSReport/getData', async params => {
  const uri =  getUriParams(params)
  
  let startDate = new Date()
  let endDate = new Date()
  const currentDay = new Date().getDate()

  const monthMidStart = startDate.getMonth() === 0 ? `${startDate.getFullYear() - 1}-12-16` : `${startDate.getFullYear()}-${endDate.getMonth()}-16`
  const monthEnd = endDate.getMonth() === 0 ? `${endDate.getFullYear() - 1}-12-${new Date(endDate.getFullYear() - 1, 12, 0).getDate()}` : `${endDate.getFullYear()}-${endDate.getMonth()}-${new Date(endDate.getFullYear(), endDate.getMonth(), 0).getDate()}`
  
  startDate = startDate.getDate() > 15 ? `${startDate.getFullYear()}-${startDate.getMonth() + 1}-${startDate.getDate() - currentDay + 1}` : monthMidStart
  endDate = endDate.getDate() > 15 ? `${endDate.getFullYear()}-${endDate.getMonth() + 1}-15` : monthEnd
  
  // Convert Date objects to ISO string format if they are Date instances
  let formattedStartDateTime = params.startDateTime
  let formattedEndDateTime = params.endDateTime
  
  if (params.startDateTime instanceof Date) {
    formattedStartDateTime = params.startDateTime.toISOString()
  }
  
  if (params.endDateTime instanceof Date) {
    formattedEndDateTime = params.endDateTime.toISOString()
  }
  
  const TimeSheetFilter = {
    userId: params.userId,
    punchType: params.punchType !== null ? params.punchType : null,
    startDateTime: formattedStartDateTime === null ? startDate : formattedStartDateTime,
    endDateTime: formattedEndDateTime === null ? endDate : formattedEndDateTime,
    siteLocation: params.siteLocation,
    status: params.status,
    isTempWorker: params.isTempWorker ?? null,
    companyId: params.companyId ?? null,
    isDriver: params.isDriver ?? false
  }
  
  const response = await axios.post(`${urlTimeSheetService}/GetTimeSheetsUserHours?${uri}`, TimeSheetFilter)
  
  return {
    params,
    data: response.data,
    totalPages: response.data.length > 0 ? response.data[0].totalCount : 0,
    loaded: true
  }
})
//get truck drives timesheet her hours
export const getDriverData = createAsyncThunk('hrmTSReport/getDriverData', async params => {
  const uri = getUriParams(params)
  let startDate, endDate
  const useDefaultDateRange = params.useDefaultDateRange === true
  
  if (useDefaultDateRange && (params.startDateTime === null || params.endDateTime === null)) {
    const today = new Date()
    const currentDay = today.getDate()
    const currentMonth = today.getMonth()
    const currentYear = today.getFullYear()
    
    if (currentDay > 15) {
      // If we're in the second half of the month (16th-end)
      // Start date is 1st of current month
      startDate = new Date(currentYear, currentMonth, 1)
      // End date is 15th of current month
      endDate = new Date(currentYear, currentMonth, 15)
    } else {
      // If we're in the first half of the month (1st-15th)
      // Start date is 16th of previous month
      const prevMonth = currentMonth === 0 ? 11 : currentMonth - 1
      const prevMonthYear = currentMonth === 0 ? currentYear - 1 : currentYear
      startDate = new Date(prevMonthYear, prevMonth, 16)
      // End date is last day of previous month
      endDate = new Date(currentYear, currentMonth, 0)
    }
    
    // Format dates as ISO strings to maintain consistency
    startDate = startDate.toISOString()
    endDate = endDate.toISOString()
  } else {
    // Convert Date objects to ISO string format if they are Date instances
    if (params.startDateTime instanceof Date) {
      startDate = params.startDateTime.toISOString()
    } else {
      startDate = params.startDateTime ?? null
    }
    
    if (params.endDateTime instanceof Date) {
      endDate = params.endDateTime.toISOString()
    } else {
      endDate = params.endDateTime ?? null
    }
  }
  
  const TimeSheetFilter = {
    userId: params.userId,
    punchType: params.punchType !== null ? params.punchType : null,
    startDateTime: startDate,
    endDateTime: endDate,
    siteLocation: params.siteLocation,
    status: params.status,
    isTempWorker: params.isTempWorker ?? null,
    companyId: params.companyId ?? null,
    IsDriver: true
  }
  
  const response = await axios.post(`${urlTimeSheetService}/GetTimeSheetsUserHours?${uri}`, TimeSheetFilter)
  
  return {
    params,
    data: response.data,
    totalPages: response.data.length > 0 ? response.data[0].totalCount : 0,
    loaded: true,
    defaultDates: {
      startDate,
      endDate
    }
  }
})

export const getPieceWorkData = createAsyncThunk('hrmTSReport/getPieceWorkData', async params => {
  //const uri =  getUriParams(params)
  let startDate = new Date()
  let endDate = new Date()
  const currentDay = new Date().getDate()
  const monthMidStart = startDate.getMonth() === 0 ? `${startDate.getFullYear() - 1}-12-16` : `${startDate.getFullYear()}-${twoDigitFormat(endDate.getMonth())}-16`
  const monthEnd = endDate.getMonth() === 0 ? `${endDate.getFullYear() - 1}-12-${new Date(endDate.getFullYear() - 1, 12, 0).getDate()}` : `${endDate.getFullYear()}-${twoDigitFormat(endDate.getMonth())}-${new Date(endDate.getFullYear(), twoDigitFormat(endDate.getMonth()), 0).getDate()}`
  
  startDate = startDate.getDate() > 15 ? `${startDate.getFullYear()}-${twoDigitFormat(startDate.getMonth() + 1)}-${twoDigitFormat(startDate.getDate() - currentDay + 1)}` : monthMidStart
  endDate = endDate.getDate() > 15 ? `${endDate.getFullYear()}-${twoDigitFormat(endDate.getMonth() + 1)}-15` : monthEnd
  
  const TimeSheetFilter = {
    //userId: params.userId,
    //punchType: params.punchType !== null ? params.punchType : null,
    from: params.startDateTime === null ? startDate : params.startDateTime,
    to: params.endDateTime === null ? endDate : params.endDateTime
    //siteLocation: params.siteLocation,
    //status: params.status
  }

  const response = await axios.post(`${urlInvoiceService}/GetPieceWorkReport`, TimeSheetFilter)
  return {
    params,
    data: response.data.data,
    totalPages: response.data.totalCount,
    loaded: true,
    from:TimeSheetFilter.from,
    to: TimeSheetFilter.to
  }
})

export const getAllEmployeesSelect =  createAsyncThunk('hrmTSReport/getAllEmployeesSelect', async () => {
  const response = await axios.get(`${urlTimeSheetService}/GetAllEmployeesSelect`)
  const allEmployees  = [{ value: null, label: 'Select...'}, ...response.data.data]
  return allEmployees
})

export const addNewTimeSheet = createAsyncThunk('hrmTSReport/addNewTimeSheet', async (TimeSheetViewModel) => {
  const response = await axios.post(`${urlTimeSheetService}/AddNewTimeSheet`, TimeSheetViewModel)
  if (response.data.success) {
    toast.success(response?.data?.messages)
  } else {
    toast.error(response?.data?.errors)
  }
})

export const updateTimeSheet = createAsyncThunk('hrmTSReport/updateTimeSheet', async (TimeSheetViewModel) => {
  const response = await axios.post(`${urlTimeSheetService}/UpdateTimeSheet`, TimeSheetViewModel)
  if (response.data.success) {
   toast.success(response?.data?.messages)
  } else {
    toast.error(response?.data?.errors)
  }
})

export const hrmTimeSheetsSlice = createSlice({
  name: 'hrmTSReport',
  initialState: {
    loaded : false,
    loadedAll: false,
    data: [],
    total: 1,
    params: {},
    allData: {},
    allEmployees:[],
    from : '',
    to : '',
    defaultDates: {
      startDate: null,
      endDate: null
    }

  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllData.pending, (state) => {
        state.loadedAll = false
      })
      .addCase(getAllData.fulfilled, (state, action) => {
        state.loadedAll = action.payload.loadedAll
        state.allData = action.payload.data
      })
      .addCase(getData.pending, (state) => {
        state.loaded = false
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.loaded = action.payload.loaded
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getPieceWorkData.pending, (state) => {
        state.loaded = false
      })
      .addCase(getPieceWorkData.fulfilled, (state, action) => {
        state.loaded = action.payload.loaded
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.from = action.payload.from
        state.to = action.payload.to
      })
      .addCase(getAllEmployeesSelect.fulfilled, (state, action) => {
        state.allEmployees = action.payload
      })
      
      .addCase(getDriverData.fulfilled, (state, action) => {
        state.loaded = action.payload.loaded
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.defaultDates = action.payload.defaultDates
      })
     .addCase(getDriverData.pending, (state) => {
        state.loaded = false
      }
      )
     
  }
})

export default hrmTimeSheetsSlice.reducer

hrmTimeSheetsSlice.metadata = {
  name: 'Zakeer Sainalabdeen',
  github: 'zakeerwtc',
  description: 'CRM Deals - Store {Get Data from Microservices}',
  filename: 'index',
  githubFile: 'https://github.com/WTCGroup/Frontend/blob/main/src/views/crm/deals/store/index.js',
  prodUrl: ''
}
